// extracted by mini-css-extract-plugin
module.exports = {"SecondaryFooter":"SecondaryFooter_SecondaryFooter__5WON7","Description":"SecondaryFooter_Description__Alrzi"};